import { CostCenterModel, CostCenterModelAPI } from '../../../../models';

export const getCostCenterGroupAdapter = (
    response: CostCenterModelAPI[]
): CostCenterModel[] => {
    return response
        ? response.map((costCenter) => {
              return {
                  costCenter: costCenter.costCenter,
                  groupId: costCenter.groupId,
                  id: costCenter.id,
              };
          })
        : [];
};
